export default "__VITE_ASSET__C$ygZNJH__"